import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useSelector } from 'react-redux';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function PortalWelcomeText({ isForm, children }) {
  const classes = useStyles();
  const { data: brandingData } = useSelector((state) => state.branding);

  // eslint-disable-next-line react/no-unstable-nested-components
  function WelcomeText() {
    return <Box className={isForm ? classes.formWelcome : classes.welcome}>{children}</Box>;
  }

  return isForm ? (
    <>
      <img className={classes.logoIcon} src={brandingData.icon} alt="Logo" />
      <Typography className={classes.header} variant="h3" component="h3" align="center">
        {brandingData.displayName}
      </Typography>
      <WelcomeText />
    </>
  ) : (
    <WelcomeText />
  );
}

PortalWelcomeText.propTypes = {
  isForm: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
};

PortalWelcomeText.defaultProps = {
  isForm: false,
  children: null,
};

export default PortalWelcomeText;
